export default {
  /**
   * 项目名称
   */
  projectname: "教育",

  /**
   * cookie储存天数
   */
  cookie: 1,

  /**
   * api基础请求路径
   */
  baseUrl: {
    dev: "https://api.fuyueopera.com/",
    pro: "https://api.fuyueopera.com/"
    // dev: "http://192.168.110.166:8070",//上线地址
    // pro: "http://192.168.110.166:8070"//测试地址
  },
  /**
   * 环境设置
   */
  plugin: {
    logs:true,//开启调试日志
  },
  /**
   * 第一次进入页面展示的首页（写二级路由的name,默认会展示选中）
   */
  homeName:"/index",
  sonindex:0, //二级路由默认展示第N个根据下标来

}



// WEBPACK FOOTER //
// ./src/config/index.js